/**
 *
 *
 * @export
 * @param {*} step
 * @returns
 */
export function toggleStep(step) {
  return {
    type: "TOGGLE_MULTIPLOS_STEP",
    step
  };
}

/**
 *
 *
 * @export
 * @returns
 */
export function resetMultiplosState() {
  return {
    type: "RESET_MULTIPLOS_STATE"
  };
}

/**
 *
 *
 * @export
 * @param {*} userId
 * @returns
 */
export function getUserId(userId) {
  return {
    type: "MULTIMPLOS_GET_USER_ID",
    userId
  };
}

/**
 *
 *
 * @export
 * @param {*} user
 * @param {*} document
 * @returns
 */
export function handleUserInfo(user, document) {
  return {
    type: "MULTIPLOS_GET_USER_INFO",
    user,
    document
  };
}

/**
 *
 *
 * @export
 * @param {*} contactId
 * @returns
 */
export function handleContactId(contactId, contact) {
  return {
    type: "MULTIPLOS_GET_CONTACT",
    contactId,
    contact
  };
}
